<template>
    <div class="pb-2">
        <b-card :title="$t('scimToken.cardTitle')" class="mb-2">
            <b-card-text>
                <p>{{ $t('scimToken.headerText') }}</p>
            </b-card-text>
            <div class="mt-3 mb-3">
                <div v-if="scimToken">
                    <b-input-group>
                        <b-form-input
                            :type="showPassword ? 'text' : 'password'"
                            id="scimToken"
                            :value="scimToken"
                            readonly
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button
                                @click="showPassword = !showPassword"
                                :disabled="!newScimToken"
                                :title="buttonPasswordTitle"
                                ><span
                                    :class="[
                                        'fa',
                                        showPassword ? 'fa-eye-slash' : 'fa-eye'
                                    ]"
                                    aria-hidden="true"
                                ></span
                            ></b-button>
                            <b-button
                                @click="$_copyToClipboard"
                                :disabled="!newScimToken"
                                :title="buttonCopyTitle"
                            >
                                {{ $t('scimToken.copyLabel') }}
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div v-else>{{ $t('scimToken.noTokenMessage') }}</div>
            </div>
            <b-button id="generate_button" @click="$_onGenerateScimToken">
                {{ $t('scimToken.generateLabel') }}
            </b-button>
            <b-button
                v-if="hasToken"
                id="delete_button"
                @click="$_onDeleteScimToken"
            >
                {{ $t('scimToken.deleteLabel') }} &nbsp;<span
                    class="far"
                    v-bind:class="'fa-trash-alt'"
                ></span>
            </b-button>
        </b-card>
    </div>
</template>

<script>
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    export default {
        mixins: [modalMixin],
        props: {
            id: { type: Number, required: false, default: -1 },
            scimToken: { type: String, required: false, default: null }
        },
        data() {
            return {
                // Constants
                newScimToken: null,
                showPassword: false
            };
        },
        computed: {
            hasToken() {
                return !!this.scimToken;
            },
            buttonPasswordTitle() {
                if (this.newScimToken) {
                    return this.$t('scimToken.passwordShowTitle');
                } else {
                    return this.$t('scimToken.copyOnceText');
                }
            },
            buttonCopyTitle() {
                if (this.newScimToken) {
                    return this.$t('scimToken.copyTitle');
                } else {
                    return this.$t('scimToken.copyOnceText');
                }
            }
        },
        methods: {
            async $_onDeleteScimToken() {
                const confirmed = await this.msgBoxConfirm({
                    message: this.$t('scimToken.deleteConfirmation')
                });

                if (confirmed) {
                    await this.$store.dispatch('useApiData', {
                        name: 'DeleteScimToken',
                        data: { organizationId: this.id }
                    });

                    this.$emit('updateToken', null);
                }
            },

            async $_onGenerateScimToken() {
                const confirmed = await this.msgBoxConfirm({
                    message: this.$t('scimToken.generateConfirmation')
                });
                if (confirmed) {
                    await this.$_generateScimToken();
                }
            },
            async $_generateScimToken() {
                try {
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GenerateScimToken',
                        data: { organizationId: this.id }
                    });
                    if (result && result.status === 200 && result.data) {
                        this.newScimToken = result.data;
                        this.showToast({
                            message: this.$t('scimToken.generateSuccessMessage'),
                            variant: 'success',
                            autoHideDelay: 5000,
                            noCloseButton: true
                        });
                        this.$emit('updateToken', result.data);
                    }
                } catch (error) {
                    console.error('Error generating token', error);
                    this.showToast({
                        message: this.$t('scimToken.generateFailureMessage'),
                        variant: 'danger',
                        autoHideDelay: 5000,
                        noCloseButton: true
                    });
                }
            },
            $_copyToClipboard() {
                navigator.clipboard
                    .writeText(this.scimToken)
                    .then(() => {
                        this.showToast({
                            message: this.$t('scimToken.copySuccessMessage'),
                            variant: 'success',
                            autoHideDelay: 5000,
                            noCloseButton: true
                        });
                    })
                    .catch((error) => {
                        console.error('Clipboard copy failed:', error);
                        this.showToast({
                            message: this.$t('scimToken.copyFailureMessage'),
                            variant: 'danger',
                            autoHideDelay: 5000,
                            noCloseButton: true
                        });
                    });
            }
        }
    };
</script>
